// Tag prefixing a structural executor directive (APPROVAL, PLAN_CLICK, ANSWER, …) encoded
// into a USER message's text, so the worker can read intent without a model round-trip.
// The builder, the parser and the payload codec live in
// apps/api/src/utils/doboxExecutor/directivePayload.ts, which imports this tag — kept here,
// not there, so a future non-API consumer (web, another lambda) can recognize the tag
// without pulling in backend-only code.
export const EXECUTOR_EVENT_TAG = 'executor_event';
